/**
 * Twilio Configuration for Testing
 * Add your actual Twilio credentials here
 */

module.exports = {
  // Get these from your Twilio Console: https://console.twilio.com/
  accountSid: 'AC104761483cc1d5e690eab8fe6d673761',     // Your actual Account SID
  authToken: 'ee8bcc26752e44305808c7b1ef9185b2',       // Your actual Auth Token
  phoneNumber: '+18778843550',                // Your actual Twilio phone number
  
  // Test phone number (your actual phone number)
  testPhoneNumber: '+12489075504',            // Your actual phone number
  
  // Optional: Business info for testing
  businessName: 'BookAPT Test Business',
  venmoUsername: '@bookapt-test',
  paypalUsername: '@bookapt-test',
};
